import { type ComponentRef, forwardRef } from "react";
import styled from "styled-components";
import {
	PlateElement,
	type PlateElementProps,
} from "@platejs/core/react";

interface TableRowElementProps extends PlateElementProps {
	readonly hideBorder?: boolean;
}

export const TableRowElement = forwardRef<
	ComponentRef<typeof PlateElement>,
	TableRowElementProps
>(({ hideBorder = false, children, ...props }, ref) => (
	<PlateElement as="tr" ref={ref} {...props}>
		<Tr $hideBorder={hideBorder}>{children}</Tr>
	</PlateElement>
));

const Tr = styled.tr<{ $hideBorder: boolean }>`
	${({ $hideBorder }) => $hideBorder && `border: none;`}
`;

TableRowElement.displayName = "TableRowElement";
